/**
 * Derive analytics actionType from eventName.
 * Mirrors @cashfree-intl/analytics getActionType (kept local so dashboard
 * does not depend on that named export being present in published types).
 */
export function getActionType(eventName: string): string {
  if (!eventName || typeof eventName !== 'string') {
    return 'other';
  }

  const name = eventName.toLowerCase();
  if (name.includes('change')) return 'input';
  if (name.includes('view')) return 'view';
  if (name.includes('hover')) return 'hover';
  if (name.includes('click')) return 'click';
  if (name.includes('scroll')) return 'scroll';
  if (name.includes('error')) return 'error';
  return 'other';
}
